<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBItemBrandList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-card-title>{{$t('views.exsbitembrand.update.title')}}  {{ item && item['brandTitle'] }}</b-card-title>
            <EXSBItemBrandForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBItemBrandForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    EXSBItemBrandForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBItemBrandUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbitembrand/update/isLoading',
      error: 'exsbitembrand/update/error',
      deleteError: 'exsbitembrand/del/error',
      deleteLoading: 'exsbitembrand/del/isLoading',
      created: 'exsbitembrand/create/created',
      deleted: 'exsbitembrand/del/deleted',
      retrieved: 'exsbitembrand/update/retrieved',
      updated: 'exsbitembrand/update/updated',
      violations: 'exsbitembrand/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBItemBrandList' })
    },

    updated: function () {
      this.$router.push({ name: 'EXSBItemBrandList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbitembrand/create/reset',
      deleteItem: 'exsbitembrand/del/del',
      delReset: 'exsbitembrand/del/reset',
      retrieve: 'exsbitembrand/update/retrieve',
      updateReset: 'exsbitembrand/update/reset',
      update: 'exsbitembrand/update/update',
      updateRetrieved: 'exsbitembrand/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbitembrand ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
